export type FetchErrorData = {
  message?: string;
  code?: string;
  status?: number;
  details?: unknown;
  errors?: Record<string, unknown>;
  [key: string]: unknown;
};

export default class FetchError extends Error {
  public response: Response;
  public message: string;
  public code?: string;
  public status: number;
  public errorData?: FetchErrorData; // Store parsed backend payload

  constructor(response: Response, message: string, code?: string, errorData?: FetchErrorData) {
    super(message);
    this.name = 'FetchError';
    this.response = response;
    this.message = message;
    this.code = code;
    this.status = response.status;
    this.errorData = errorData;
  }
}
